import React from 'react';
// 相关文档https://git.ifengidc.com/whale/web-ui/-/tree/master/src/mobile/video
import { pics } from '../../../../../../../pics';
import { formatImage } from '../../../../../../../../base/publicMethod/formatImage';

import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng/ui_pc_lazyLoad';
import styles from './index.css';
import DefaultImg from '../../img/defaultImg.png';
import {  setH5PageTouchArea, setNoSlideArea } from '../../../utils/app';
//import { image2Base64 } from '../../../utils/media';
//import { isIOS } from '../../../utils/index';
const smallLazyImg = DefaultImg;

const bigLazyImg = DefaultImg;
const bol = true;

const ImgView = ({ img }) => {
    img = img?.map(item => {
        let url = item;
        let isLongImage = false;
        let isGifImgage = false;

        if (url.includes('.gif')) {
            isGifImgage = true;
        }

        url = url.includes('.gif')
            ? url.replace(/\.webp|_webp/g, '')
            : formatImage(url.replace(/\.webp|_webp/g, ''), 340, 340);

        const imgReg =
            (url &&
                url.split('/') &&
                url.split('/').pop() &&
                url
                    .split('/')
                    .pop()
                    .split('.') &&
                url
                    .split('/')
                    .pop()
                    .split('.')[0] &&
                url
                    .split('/')
                    .pop()
                    .split('.')[0]
                    .split('_')) ||
            [];

        const imgWidth = (imgReg[1] && imgReg[1].replace('w', '')) || 0;
        const imgHeight = (imgReg[2] && imgReg[2].replace('h', '')) || 0;

        if (imgWidth && imgHeight && (imgWidth / imgHeight < 0.66 || imgWidth / imgHeight > 2)) {
            isLongImage = true;
        }

        return {
            url,
            isLongImage,
            isGifImgage,
            initialUrl: item,
        };
    });

    const handleShowPic = (e, index) => {
        if (typeof window ===undefined) {
            window = {}
        }
        const imageList = img;

        if (imageList) {
            const list = imageList.filter(item => item?.initialUrl)?.map(item => {
                const { initialUrl } = item;
                const reg = /_w([0-9]+)_h([0-9]+)\.[a-zA-Z]+$/gi;

                if (reg.test(initialUrl)) {
                    const width = parseInt(RegExp.$1);
                    const height = parseInt(RegExp.$2);

                    return { url: initialUrl, width, height };
                } else {
                    return { url: initialUrl, width: 690, height: 990 };
                }
            });

            if (window?.grounds?.openSlide) {
                const { width, height, top, left } = e.target.getBoundingClientRect();

                window.grounds.openSlide(
                    JSON.stringify(imageList?.filter(item => item?.initialUrl)?.map(item => `${item?.initialUrl}`)),
                    index,
                    {
                        top,
                        left,
                        width,
                        height,
                        img:
                            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAyKADAAQAAAABAAAAyAAAAACbWz2VAAAC0UlEQVR4Ae3QgQAAAADDoPlTH+SFUGHAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgIGvgQFx5gABkajORgAAAABJRU5ErkJggg==',
                    },
                );

                return;
            }

            pics.show({
                list,
                current: index,
                // 配置对象不需要可以不写
                options: {
                    statusBarHeight: `${0}px`,
                    onShow: () => {
                        setNoSlideArea([{ top: 0, end: window.innerHeight, type: 'fixed' }]);
                        setH5PageTouchArea(0, window.innerHeight, window.innerHeight);
                    },
                    onClose: () => {
                        setNoSlideArea([
                            { top: window.h5PageTouchAreaTop, end: window.window.h5PageTouchAreaBottom, type: 'fixed' },
                        ]);
                        // 还原初始值，或去掉禁止的手势
                        setH5PageTouchArea(
                            window.h5PageTouchAreaTop || 0,
                            window.h5PageTouchAreaBottom || 0,
                            window.innerHeight,
                        );
                    },
                },
            });
        }
    };

    const lessThanThreeImg = wbImages => {
        return (
            <ul className={styles.wbImgBox}>
                <li className={styles.wbImgGroup}>
                    {wbImages.length === 1 && (
                        <div
                            className={`${styles.wbImgItem} ${styles.onlyWbImgItemPic}`}
                            onClick={e => {
                                handleShowPic(e, 0);
                            }}>
                            <LazyImg className={styles.wbImgItemPic} placeholder={bigLazyImg} src={wbImages[0].url} />
                            {wbImages[0].isLongImage &&
                                !wbImages[0].isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                            {wbImages[0].isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                        </div>
                    )}
                    {wbImages.length === 2 && (
                        <>
                            {wbImages.map((item, index) => (
                                <div
                                    key={index}
                                    className={styles.wbImgItem}
                                    onClick={e => {
                                        handleShowPic(e, index);
                                    }}>
                                    <div className={styles.wbImgItemBox}>
                                        <LazyImg
                                            className={styles.wbImgItemPic}
                                            placeholder={smallLazyImg}
                                            src={item.url}
                                        />
                                        {item.isLongImage &&
                                            !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                        {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                    </div>
                                </div>
                            ))}
                            <div className={styles.wbImgItem} />
                        </>
                    )}
                    {wbImages.length === 3 &&
                        wbImages.map((item, index) => (
                            <div
                                key={index}
                                className={styles.wbImgItem}
                                onClick={e => {
                                    handleShowPic(e, index);
                                }}>
                                <div className={styles.wbImgItemBox}>
                                    <LazyImg
                                        className={styles.wbImgItemPic}
                                        placeholder={smallLazyImg}
                                        src={item.url}
                                    />
                                    {item.isLongImage &&
                                        !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                    {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                </div>
                            </div>
                        ))}
                </li>
            </ul>
        );
    };

    const equalFourImg = wbImages => {
        const imageGroup = [];

        for (let i = 0, len = wbImages.length; i < len; i += 2) {
            imageGroup.push(wbImages.slice(i, i + 2));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div
                                key={index}
                                className={styles.wbImgItem}
                                onClick={e => {
                                    // eslint-disable-next-line no-unused-expressions
                                    item.url && handleShowPic(e, indexGroup * 2 + index);
                                }}>
                                <div className={styles.wbImgItemBox}>
                                    <LazyImg
                                        className={styles.wbImgItemPic}
                                        placeholder={smallLazyImg}
                                        src={item.url}
                                    />
                                    {item.isLongImage &&
                                        !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                    {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                </div>
                            </div>
                        ))}
                        <div className={styles.wbImgItem} />
                    </li>
                ))}
            </ul>
        );
    };

    const greaterThanFiveImg = wbImages => {
        const imageGroup = [];
        const fillIndex = 3 - (wbImages.length % 3);

        for (let j = 0; j < fillIndex; j++) {
            if (fillIndex !== 3) {
                wbImages.push('');
            }
        }
        for (let i = 0, len = wbImages.length; i < len; i += 3) {
            imageGroup.push(wbImages.slice(i, i + 3));
        }

        return (
            <ul className={styles.wbImgBox}>
                {imageGroup.map((itemGroup, indexGroup) => (
                    <li key={indexGroup} className={styles.wbImgGroup}>
                        {itemGroup.map((item, index) => (
                            <div
                                key={index}
                                className={styles.wbImgItem}
                                onClick={e => {
                                    // eslint-disable-next-line no-unused-expressions
                                    item.url && handleShowPic(e, indexGroup * 3 + index);
                                }}>
                                {item.url && (
                                    <div className={styles.wbImgItemBox}>
                                        <LazyImg
                                            className={styles.wbImgItemPic}
                                            placeholder={smallLazyImg}
                                            src={item.url}
                                        />
                                        {item.isLongImage &&
                                            !item.isGifImgage && <span className={styles.wbImgMark}>长图</span>}
                                        {item.isGifImgage && <span className={styles.wbImgMark}>动图</span>}
                                    </div>
                                )}
                            </div>
                        ))}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <div>
            {img?.length > 0 && (
                <div className={styles.shortRelateBox}>
                    {img.length < 4 && lessThanThreeImg(img)}
                    {img.length === 4 && equalFourImg(img)}
                    {img.length > 4 && greaterThanFiveImg(img)}
                </div>
            )}
        </div>
    );
};

ImgView.propTypes = {
    /**
     * 图片
     */
    img: PropTypes.array,
};

export default ImgView;
